<template>
	<div>
		<h2>Import</h2>
		<div class="btn btn-primary" @click="importProcess">
			Importa
		</div>
		<div class="row" v-if="prepareRes">
			<div class="col">
				<h4>Sites: </h4>
				{{ countings.sites }}/{{prepareRes.data.length}}
			</div>
			<div class="col">
				<h4>Engine</h4>
				{{ countings.engines }}/{{engineLength}}
			</div>
			<div class="col">
				<h4>Revisions</h4>
				{{ countings.revisions }}/{{revisionLength}}
			</div>
		</div>
		<pre>
			{{prepareRes}}
		</pre>
	</div>
</template>
<script>
	import axios from 'axios'

	export default  {
		name : 'import',
		mounted() {
			this.callPrepare()
		},
		computed: {
			engineLength() {
				if (!this.prepareRes){
					return 0
				}

				let len = 0;
				for (let site of this.prepareRes.data){
					// console.log(site)
					len = len + site.engines.length
				}
				return len
			},
			revisionLength() {
				if (!this.prepareRes){
					return 0
				}

				let len = 0;
				for (let site of this.prepareRes.data){
					// console.log(site)
					for (let engine of site.engines){
						len = len + engine.revisions.length
					}
				}
				return len
			}
		},
		methods: {
			async callPrepare() {
				const res =  await axios.get('/api/import/prepare')
				this.prepareRes = res.data
			},
			async importProcess() {
				console.log(new Date())
				for (let site of this.prepareRes.data){
					const engines = site.engines;
					delete site.engines;

					const {data} = await axios.post(`/api/sites`,{site})
					this.countings.sites++
					const siteId = data.id;
					for (let engine of engines){
						const revisions = engine.revisions;
						delete engine.revisions;
						engine.site = siteId;

						const {data} = await axios.post(`/api/sites/${siteId}/engines`,{engine})
						this.countings.engines++
						const engineId = data.id

						for (let revision of revisions){
							revision.engine = engineId

							const { data } = await axios.post(`/api/engines/${engineId}/revisions`,{revision})
							this.countings.revisions++
						}

					}
				}
				console.log(new Date())
				
			}
		},
		data() { 
			return {
				prepareRes : null,
				countings: {
					sites: 0,
					engines: 0,
					revisions: 0
				}
			}
		}
	}
</script>